import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'shared/lib';

import { selectAdditionalInfoData } from 'entities/creditForm';
import { selectMfoData } from 'entities/mfo/model/mfoForm.selectors';
import { setMfoInfo } from 'entities/mfo/model/mfoForm.slice';

export const useInitSnilsData = () => {
  const additionalData = useAppSelector(selectAdditionalInfoData);
  const mfoData = useAppSelector(selectMfoData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!mfoData?.snils) {
      dispatch(setMfoInfo({ snils: additionalData?.snils }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalData?.snils]);
};
